import { render, staticRenderFns } from "./MeetingRoom.vue?vue&type=template&id=4ef06f3e&scoped=true"
import script from "./MeetingRoom.vue?vue&type=script&lang=js"
export * from "./MeetingRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef06f3e",
  null
  
)

export default component.exports